import React from 'react'
import CountiesCodeModal from '../../modals/CountriesCodeList'
import { checkTextTranslation, getCookie, getCountryCodeOfPhoneNumber, setCookie } from '../../utils/useful'
import HttpServices from '../../utils/Http.services'

class PhoneInput extends React.Component {
    state = {
        selectedCountry: {}
    }

    componentDidMount() {

        let code = getCountryCodeOfPhoneNumber(this.props.data)?.country

        // console.log(this.props.data, code)
        // const locale = navigator.language 
        // console.log(locale)
        if (code) {
            this.selectByCountryCode(code)

        } else {
            this.getUserDefaultCode()

        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.data !== this.props.data) {

            // console.log(this.props.data)

            if (this.props.data) {

                let code = getCountryCodeOfPhoneNumber(this.props.data)?.country

                // console.log(this.props.data,code)
                // let code = this.props.data.includes('-') ? this.props.data.substring(0, 6) : this.props.data.substring(0, 4)
                // console.log('this.props.datac1',this.props.data.substring(0, 4),code)
                if (this.state.selectedCountry?.code !== code) {

                    // let country = getCountryCodeOfPhoneNumber(this.props.data)?.country

                    if (code) {
                        this.selectByCountryCode(code, true)
                    }
                }
            } else {
                this.getUserDefaultCode()
            }
        }

    }


    getUserDefaultCode() {

        let cookieData = getCookie('user_country')

        if (cookieData) {

            this.selectByCountryCode(cookieData, true)

        } else {

            this.selectByCountryCode('US', true)

            HttpServices.request('getMyIPInfo', {}, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }

                if (fetchResult.country) {
                    setCookie('user_country', fetchResult.country)
                }
            })
        }




    }


    changeInputValue(target) {
        // console.log("changeInputValue")
        let value = (target?.validity.valid) ? target?.value : null
        if (value !== null && this.state.selectedCountry?.dial_code) {
            // console.log(this.valueToNumber(value))
            // console.log(this.state.selectedCountry.dial_code)
            value = this.state.selectedCountry.dial_code + this.valueToNumber(value)
            // console.log(value)
            if (value && !value.startsWith('+')) {
                value = '+' + value
            }
            // console.log("changeInputValue",value)
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }


    codeToCountry(code, lastAttempt) {
        // console.log('this.props.datac1',value)
        // let code = ""
        // if (value) {
        //     code = value.includes('-') ? value.substring(0, 7) : value.substring(0, 4) 
        //     // console.log('this.props.datac2',code)
        // }
        this.countiesCodeModal.selectByCode(code, lastAttempt)
    }

    selectByCountryCode(code, lastAttempt) {

        this.countiesCodeModal.selectByCountryCode(code, lastAttempt)
    }


    openCountiesModal() {
        this.countiesCodeModal.showModal()
    }

    selectCountyCode = (selectedCountry) => {

        // console.log("selectCountyCode")
        let currentCode = (this.state.selectedCountry?.dial_code ?? '+1')
        if (currentCode && !currentCode.startsWith('+')) {
            currentCode = '+' + currentCode
        }
        let currentMainData = this.valueToNumber(this.props.data)
        this.setState({ selectedCountry }, () => {

            let value

            console.log(this.props.data,currentMainData, currentCode)

            if (currentMainData && currentMainData.length > 0 && !currentMainData.startsWith('+')) {

                value = this.state.selectedCountry?.dial_code + currentMainData

                if (value && !value.startsWith('+')) {
                    value = '+' + value
                }
                console.log("selectCountyCode",value)

                this.props.changeValue(this.props.header.key, value, this.props.extra)

            }


            // console.log("selectCountyCode", value, this.props.data)


            // this.props.changeValue('countryCode', selectedCountry.code)
            // setTimeout(() => {
            //     this.changeInputValue(this.input)
            // }, 100);
        })
    }

    valueToNumber(value) {

        // console.log("valueToNumber", value)
        let newValue = value
        if (value) {

            let code = this.state.selectedCountry?.dial_code//getCountryCodeOfPhoneNumber(value)

            // console.log(code)
            if (code) {
                if (!code.startsWith('+')) {
                    code = "+" + code
                }

                // console.log(code)

                newValue = newValue.replace(code, '')
            }

            // console.log(code, newValue)
            // console.log(value)
            // if (this.state.selectedCountry?.dial_code && value !== '') {
            //     newValue = newValue.substring(newValue.includes('-') ? 7 : 4, newValue.length)
            // }
        } else {
            newValue = ""
        }
        // console.log(newValue)
        return newValue
    }

    valueToCode(value) {
        if (value && value !== "") {
            // let newValue = value.includes('-') ? value.substring(3, value.length) : value
            let newValue = String(Number(value))
            return newValue
        } else {
            return ""
        }
    }

    render() {
        return (
            <div className="w-100 h-100 flexcc" style={{ direction: 'ltr' }}>
                <div onClick={() => { if (!this.props.header.information.disabled) { this.openCountiesModal() } }} className="flexcc cursor-pointer">
                    <p style={{ fontSize: 15, lineHeight: '10px' }} >{this.state.selectedCountry?.flag}</p>
                    <p style={{ fontSize: 15, margin: '0px 7px 0px 10px' }}>+{this.valueToCode(this.state.selectedCountry?.dial_code)}</p>
                </div>
                <input ref={el => this.input = el} autoFocus={this.props.header.information.autoFocus} disabled={this.props.header.information.disabled} maxLength="10" pattern="[0-9]*" value={this.valueToNumber(this.props.data)} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} className="transpanet-input" />

                <CountiesCodeModal ref={el => this.countiesCodeModal = el} selectCountyCode={this.selectCountyCode} selectedCountry={this.state.selectedCountry} />

            </div>
        )
    }
}

export default (PhoneInput);